import { UnidadeProdutiva } from "src/app/entities/unidade-produtiva";
import { Component, Input, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import {
  ContainerNota,
  ContainerNotaVdpResponse,
} from "src/app/entities/NotaCertificacao";
import { ToastService } from "src/app/services/toast.service";
import { ToastType } from "src/app/entities/toast";

@Component({
  selector: "app-exibir-vdp",
  templateUrl: "./exibir-vdp.component.html",
})
export class ExibirVdpComponent implements OnInit {
  @Input() unidadeProdutiva: UnidadeProdutiva;
  @Input() loading: boolean;
  @Input() containerNota: ContainerNotaVdpResponse;

  constructor(
    private modalService: NgbModal,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {}

  open(content) {
    if (!this.containerNota.temNotaAbr || !this.containerNota.temNotaBci) {
      return this.toastService.showToast(
        ToastType.INFO,
        "Resumo VDP",
        "Etapa VDP não iniciada."
      );
    }

    this.modalService.open(content, { centered: true, size: "xl" });
  }
}
